<template>
  <div>
    <v-row>
      <v-col>
        <h1 class="text-left mx-4 my-1">Rejected Payslips</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="mx-2">
          <!-- <v-col>
          <p class="text-left font-weight-medium">Payroll Group: {{emp.group}} </p>
          <p class="text-left font-weight-medium">Pay Period: {{moment(emp.date, 'YYYY-MM-DD').format('LL')}} </p>
      </v-col> -->

          <v-row class="mx-2 py-1" id="rejected-payslip-row">
            <v-col cols="12" md="4" sm="6">
              <!-- <p class="text-left mx-2 mb-1">Payroll Group</p> -->
              <v-autocomplete
                outlined
                dense
                flat
                rounded
                solo
                label="Select Payroll Group"
                class="rounded-input font-weight-medium"
                :items="payroll_groups"
                v-model="payroll_group"
                item-text="title"
                item-value="id"
                hide-details
                return-object
                @change="getAllPayslipGroups"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <!-- <p class="text-left mx-2 mb-1">Payroll Group</p> -->
              <v-autocomplete
                outlined
                dense
                flat
                rounded
                solo
                label="Select Payslips"
                class="rounded-input font-weight-medium"
                :items="payroll_group ? payslip_groups : []"
                v-model="selected_payslip_group"
                item-text="title"
                item-value="id"
                hide-details
                return-object
                @change="getGroupPayslips();handleTourAfterClick();"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
              v-if="payslip_group.id && payslip_group.group_payslips.length > 0"
              v-model="search"
              class="my-0"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>

            <!-- <v-col cols="12" md="1">
              <v-btn
                @click="generatePayslipData"
                :disabled="!(payroll_group && date)"
              >
                <v-icon>mdi-sync</v-icon>
              </v-btn>
            </v-col> -->
            <!-- <v-spacer></v-spacer> -->
          </v-row>

          <v-row>
            <v-col>
              <v-form>  
                <v-data-table
                  :headers="headers"
                  :items="payslip_group.group_payslips"
                  class="mx-3 my-2"
                  :search="search"
                  disable-pagination
                  hide-default-footer
                  v-if="payslip_group.id"
                >
                  <template v-slot:item.total_working="{item}">
                    <!-- <span>{{ item.monthly_attendance_data.worked_days }}/{{ item.monthly_attendance_data.total_days }}</span> -->
                    <span>{{ item.monthly_attendance_data.total_days }}</span>
                  </template>
                  <template v-slot:item.total_worked="{item}">
                    <!-- <span>{{ item.monthly_attendance_data.worked_days }}/{{ item.monthly_attendance_data.total_days }}</span> -->
                    <span>{{ item.monthly_attendance_data.worked_days }}</span>
                  </template>
                  <template v-slot:item.late_marks="{item}">
                    <span>{{ item.monthly_attendance_data.late_marks == 0 ? '-' :item.monthly_attendance_data.late_marks }}</span>
                  </template>
                  <template v-slot:item.leaves="{item}">
                    <span>{{ item.monthly_attendance_data.leaves == 0 ? '-' :item.monthly_attendance_data.leaves }}</span>
                  </template>
                  <template v-slot:item.unpaid_leaves="{item}">
                    <span>{{ item.monthly_attendance_data.unpaid_leaves == 0 ? '-' :item.monthly_attendance_data.unpaid_leaves }}</span>
                  </template>
                  <template v-slot:item.half_days="{item}">
                    <span>{{ item.monthly_attendance_data.half_days == 0 ? '-' :item.monthly_attendance_data.half_days }}</span>
                  </template>
                  <template v-slot:item.unpaid_half_days="{item}">
                    <span>{{ item.monthly_attendance_data.unpaid_half_days == 0 ? '-' :item.monthly_attendance_data.unpaid_half_days }}</span>
                  </template>
                  <template v-slot:item.overtime_hours="{item}">
                    <!-- <span>{{ item.monthly_attendance_data.overtime_days == 0 ? '-' : Helper.secondsToHms(item.monthly_attendance_data.overtime_hours) }}</span> -->
                    <span>{{ moment.duration(item.monthly_attendance_data.overtime_hours).asSeconds() == 0 ? '-' : Helper.secondsToHms(moment.duration(item.monthly_attendance_data.overtime_hours).asSeconds()) }}</span>
                  </template>
                  <template v-slot:item.ot_rate="{item}">
                    <span>{{ Helper.currencyFormat(item.ot_rate) }}</span>
                  </template>
                  <template v-slot:item.loss_of_pay="{item}">
                    <span>{{ Helper.currencyFormat(item.loss_of_pay) }}</span>
                  </template>

                  <template
                    v-for="particular in payslip_group.payroll_group
                      .particulars"
                    v-slot:[`item.${particular.code}`]="{ item }"
                  >
                    <div :key="particular.code">
                      {{
                        Helper.currencyFormat(
                          item.payslip_transactions.find(
                            (transaction) =>
                              transaction.particular.code == particular.code
                          ).amount
                        )
                      }}
                    </div>
                  </template>

                  <template
                    v-for="particular in payslip_group.payslip_groups_dynamic_payslip_particulars"
                    v-slot:[`item.${particular.id}`]="{ item }"
                  >
                    <div :key="particular.id">
                      {{
                          item.payslip_dynamic_transactions.find(
                          (transaction) =>
                            transaction.particular.id == particular.id
                        ) ? 
                        Helper.currencyFormat(
                        item.payslip_dynamic_transactions.find(
                          (transaction) =>
                            transaction.particular.id == particular.id
                        ).amount)  : '-'
                      }}
                    </div>
                  </template>

                  <template v-slot:item.total_earnings="{ item }">
                    <b>{{ Helper.currencyFormat(findTotalEarnings(item)) }} </b>
                  </template>

                  <template v-slot:item.total_deductions="{ item }">
                    <b>{{
                      Helper.currencyFormat(findTotalDeductions(item))
                    }}</b>
                  </template>

                  <template v-slot:item.net_salary="{ item }">
                    <b>{{ Helper.currencyFormat(item.net_salary) }}</b>
                  </template>

                  <template v-slot:item.manipulated="{ item }">
                    <div v-if="item.manipulated">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"> mdi-information </v-icon>
                        </template>
                        <span
                          >One or more values of attendance or payroll information have been modified for this payslip.</span
                        >
                      </v-tooltip>
                    </div>
                    <span v-else>-</span>
                  </template>

                  <template v-slot:item.reason="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                v-bind="attrs"
                                v-on="on"
                                >{{ item.reason.substring(0,10) }}{{ item.reason.length > 10 ? '...' : '' }}</span>
                            </template>
                            <span>{{ item.reason }}</span>
                        </v-tooltip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <div v-if="currentUser.privileges.canEditPayrollPayslips || currentUser.privileges.canDeletePayrollPayslips || currentUser.privileges.canViewPrintablePayrollPayslips">
                      <v-btn text color="primary" :to="{ name: 'EditEmployeePayslip', params:{ payslip_id: item.id } }" v-if="currentUser.privileges.canEditPayrollPayslips">Edit</v-btn>
                      <v-btn text @click="openDialog(item)" color="red" v-if="currentUser.privileges.canDeletePayrollPayslips">Delete</v-btn>
                      <v-btn text :to="{ name: 'ViewPayslip', params: { payslip_id: item.id } }" v-if="currentUser.privileges.canViewPrintablePayrollPayslips">View</v-btn>
                    </div>
                    <div v-else>
                      <strong>-</strong>
                    </div>
                  </template>
                </v-data-table>
                <div v-else>
                  No data available
                </div>
              </v-form>
            </v-col>
          </v-row>
          <v-col> </v-col>
          <v-col> </v-col>
        </v-card>
      </v-col>
    </v-row>

    <!-- Approve Confirmation -->
    <v-row justify="center">
			<ConfirmationDialog
				title="Delete Payslip?"
				description="Are you sure you want to delete this payslip? This action cannot be undone. You have to generate the payslip for this employee again in the Generate Payslip page. You can consider editing the payslip if there are any changes."
				successText="Proceed"
				@successCallback="deletePayslip"
				failureText="Cancel"
				@failureCallback="closeDialog"
				:visible="dialog"
			>
				
			</ConfirmationDialog>
		</v-row>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import Helper from "@utils/misc";
import ConfirmationDialog from "@components/widgets/dialogs/ConfirmationDialog";
import TourHelper from "@utils/tour_helper";


export default {
  name: "RejectedPayslips",
  props: {
    payroll_group: {
      default: () => {},
      type: Object,
    },
    selected_payslip_group: {
      default: () => {},
      type: Object,
    },
    search: {
      default: null,
      type: String,
    }
  },
  components:{
    ConfirmationDialog
  },
  data() {
    return {
      moment: moment,
      Helper: Helper,
      dialog: false,
      dialog_data: {
        payslip_id: null,
      },
      paymentModes: [
        {
          display: 'Cash',
          value : "0"
        },
        {
          display: 'Cheque',
          value : "1"
        },
        {
          display: 'DD',
          value : "2"
        },
        {
          display: 'NEFT/RTGS',
          value: "3"
        },
        {
          display: 'Online/Netbanking',
          value: "4"
        },
        {
          display: 'Debit Card',
          value: "5"
        },
        {
          display: 'Credit Card',
          value: "6"
        }


      ],
      rules: {
				required: (v) => !!v || "Required",
			},
      headers: [
        {
          text: "Employee ID",
          align: "start",
          sortable: true,
          value: "account.staff.employee_id",
        },
        {
          text: "Name",
          align: "center",
          value: "account.staff.full_name",
          width: '100px',
        },
      ],
      payroll_groups: [],
      payslip_groups: [],
      payslip_group: {},
      snackbar: {
        visible: false,
        text: "",
        color: "dark",
      },
    };
  },
  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Welcome to Pending Payslips", description: "View all your Pending Payslips related information under this Section.", videoLink: "https://youtube.com"});
        steps.push({id: '2', description: "Select payslip group and month year from dropdowns to view payslip information.", el: '#rejected-payslip-row'});
        TourHelper.startTour(this, "rejected__payslips", steps);
    },

    handleTourAfterClick(){
        var steps = [];
        steps.push({id: '1', description: "<b>Total Working Hours: </b> we get this from staff attendance <br> <b>OT hours:</b> Owertime hours as specified in staff attendance ", videoLink: "https://youtube.com"});
        steps.push({id: '2', description: "Earnings are specified in <b style='color:#8dd7cf;'>Total Earnings</b>, Deductions in <b style='color:#e9a2ad;'>Total Deductions</b> and <b style='color:#b2acfa;'>Net Salary</b> "});
        steps.push({id: '3', description: "<b>Swipe Right to see for further actions:-</b> <br> <br> <b>Approved:</b> approve the selected payslip <br><br> <b>Reject:</b>Reject the selected payslip <br><br> <b>View:</b> View and save selected payslip"});
        TourHelper.startTour(this, "rejected__payslips__after__click", steps);
    },


    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    openDialog(payslip){
      this.dialog_data.payslip_id = payslip.id
      this.dialog = true
    },

    closeDialog(){
      this.dialog = false;
      this.dialog_data = {
        payslip_id: null,
      }
    },

    resetHeaders() {
      this.headers = [
        {
          text: "Employee ID",
          align: "start",
          sortable: true,
          value: "account.staff.employee_id",
        },
        {
          text: "Name",
          align: "center",
          value: "account.staff.full_name",
          width: '100px',
        },
      ];
    },

    findTotalEarnings(payslip) {
      var earning_particulars = payslip.payslip_transactions.filter(
        (transaction) => transaction.particular.particular_type == "E"
      );
      var dynamic_earning_particulars = payslip.payslip_dynamic_transactions.filter(
        (transaction) => transaction.particular.particular_type == "E"
      );

      var total_particulars_earning = Helper.totalSum(
        earning_particulars,
        "amount"
      );
      var total_dynamic_particulars_earning = Helper.totalSum(
        dynamic_earning_particulars,
        "amount"
      );

      var total_earnings =
        total_particulars_earning + total_dynamic_particulars_earning;
      return total_earnings;
    },

    findTotalDeductions(payslip) {
      var deduction_particulars = payslip.payslip_transactions.filter(
        (transaction) => transaction.particular.particular_type == "D"
      );
      var dynamic_deduction_particulars = payslip.payslip_dynamic_transactions.filter(
        (transaction) => transaction.particular.particular_type == "D"
      );

      var total_particulars_deduction = Helper.totalSum(
        deduction_particulars,
        "amount"
      );
      var total_dynamic_particulars_deduction = Helper.totalSum(
        dynamic_deduction_particulars,
        "amount"
      );

      var total_deductions =
        total_particulars_deduction + total_dynamic_particulars_deduction;
      return total_deductions;
    },

    appendAttendanceHeaders(){
      // Total Working
      if(this.payslip_group.account_OT || this.payslip_group.account_leaves || this.payslip_group.account_late_marks){
        this.headers.push({
          text: 'Total Working',
          value: 'total_working',
          sortable: false,
        })
        this.headers.push({
          text: 'Total Worked',
          value: 'total_worked',
          sortable: false,
        })
      } 
      // OT hours and rate
      if(this.payslip_group.account_OT){
        this.headers = this.headers.concat(
          [
            {
              text: 'OT Hours',
              value: 'overtime_hours',
              sortable:false,
            },
            {
              text: 'OT Rate',
              value: 'ot_rate',
              sortable: false,
            }
          ]
        )
      }
      // late marks 
      if(this.payslip_group.account_late_marks){
        this.headers.push({
          text: 'Late Marks',
          value: 'late_marks',
          sortable: false,
        })
      }
      // Leaves and hafldays

      if(this.payslip_group.account_leaves){
        this.headers = this.headers.concat(
          [
            {
              text: 'Leaves',
              value: 'leaves',
              sortable:false,
            },
            {
              text: 'Unpaid Leaves',
              value: 'unpaid_leaves',
              sortable: false,
            },
            {
              text: 'Half Days',
              value: 'half_days',
              sortable: false,
            },
            {
              text: 'Unpaid Half Days',
              value: 'unpaid_half_days',
              sortable: false,
            },
            {
              text: 'Loss of Pay',
              value: 'loss_of_pay',
              sortable: false,
            }
          ]
        )
      }
    },

    appendEarningsHeaders() {
      var earning_particulars = this.payslip_group.payroll_group.particulars.filter(
        (particular) => particular.particular_type == "E"
      );
      var dynamic_earning_particulars = this.payslip_group.payslip_groups_dynamic_payslip_particulars.filter(
        (particular) => particular.particular_type == "E"
      );

      //payroll group earning particulars
      var earning_headers = earning_particulars.map((particular) => ({
        text: particular.title,
        value: particular.code,
        class: "earning",
        sortable: false,
      }));
      // dynamic earning particulars
      earning_headers = earning_headers.concat(
        dynamic_earning_particulars.map((particular) => ({
          text: particular.title,
          value: particular.id,
          class: "earning",
          sortable: false,
        }))
      );

      var total_earnings_header = {
        text: "Total Earnings",
        value: "total_earnings",
        class: "earning",
        sortable: false,
      };

      this.headers = this.headers.concat(
        earning_headers.concat(total_earnings_header)
      );
    },

    appendDeductionsHeaders() {
      var deduction_particulars = this.payslip_group.payroll_group.particulars.filter(
        (particular) => particular.particular_type == "D"
      );
      var dynamic_deduction_particulars = this.payslip_group.payslip_groups_dynamic_payslip_particulars.filter(
        (particular) => particular.particular_type == "D"
      );

      //payroll group earning particulars
      var deduction_headers = deduction_particulars.map((particular) => ({
        text: particular.title,
        value: particular.code,
        class: "deduction",
        sortable: false,
      }));
      // dynamic earning particulars
      deduction_headers = deduction_headers.concat(
        dynamic_deduction_particulars.map((particular) => ({
          text: particular.title,
          value: particular.id,
          class: "deduction",
          sortable: false,
        }))
      );

      var total_deductions_header = {
        text: "Total Deductions",
        value: "total_deductions",
        class: "deduction",
        sortable: false,
      };

      this.headers = this.headers.concat(
        deduction_headers.concat(total_deductions_header)
      );
    },

    appendTotalHeader() {
      var total_header = {
        text: "Net Salary",
        value: "net_salary",
        class: "net",
        sortable: false,
      };
      this.headers = this.headers.concat(total_header);
    },

    appendReasonAndActionHeaders() {
      this.headers.push({
        text: "Manipulated",
        value: "manipulated",
        align: 'center',
        sortable: false,
      })
      var reason_header = {
        text: "Reason",
        value: "reason",
        sortable: false,
      };
      var action_header = {
        text: "Actions",
        value: "actions",
        width: '320px',
        align: "center",
        sortable: false,
      };
      this.headers = this.headers.concat([reason_header,action_header]);
    },
  
    async deletePayslip(){
        var url = endpoints.payslip + `${this.dialog_data.payslip_id}/`
      var response = await api.call(this.essentials, url, api.Methods.DELETE)
      if(response){
        this.snackbar.text = "Payslip deleted."
        this.snackbar.visible = true
      }
      this.getGroupPayslips();
      this.closeDialog();
    },

    async getGroupPayslips() {
      this.resetHeaders();

      var url = Helper.addUrlParams(endpoints.payslipGroups, [
        `id=${this.selected_payslip_group.id}`,
        `payslip_status=False`
      ]);
      this.payslip_group = await api.call(this.essentials, url);

      this.appendAttendanceHeaders();
      this.appendEarningsHeaders();
      this.appendDeductionsHeaders();
      this.appendTotalHeader();
      this.appendReasonAndActionHeaders();
    },

    async getAllPayslipGroups() {
      var url = Helper.addUrlParams(endpoints.payslipGroups, [
        `payroll_group_id=${this.payroll_group.id}`,
      ]);
      this.payslip_groups = await api.call(this.essentials, url);
      return this.payslip_groups;
    },

    async getAllPayrollGroups() {
      this.payroll_groups = await api.call(
        this.essentials,
        endpoints.payrollGroups
      );
    },
  },
  created() {
    this.getAllPayrollGroups();
    this.handleTour();
    if (this.payroll_group.id && this.selected_payslip_group.id) {
      this.getAllPayslipGroups();
      this.getGroupPayslips();
    }
  },
};
</script>

<style>
.earning {
  background-color: #8dd7cf;
}

.deduction {
  background-color: #e9a2ad;
}

.net {
  background-color: #b2acfa;
}
.selections {
  max-width: min-content;
}
</style>